import React from 'react';
import { motion } from 'framer-motion';
import type { DistributionRow } from '../../utils/pulse';
interface PeerBarsProps {
  rows: DistributionRow[];
  /** Suffix after each percentage, e.g. "ranked #1". */
  suffix?: string;
  /** Optional bar colour per row id, e.g. { diagnosis: 'bg-blue' }. */
  colors?: Record<string, string>;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function PeerBars({
  rows,
  suffix,
  colors
}: PeerBarsProps) {
  return <ul className="flex flex-col gap-3" data-id="element-130" data-mp="3q738yi14li49">
      {rows.map((row, i) => {
      const bar = colors?.[row.id] ?? (row.isMine ? 'bg-blue' : 'bg-navy2/35');
      return <motion.li key={row.id} initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.22,
        delay: 0.04 + i * 0.05,
        ease: EASE
      }} className={row.isMine ? 'rounded-lg bg-mist px-2.5 py-2 -mx-2.5' : ''} data-id="element-131" data-mp="3hbdrgk2st7w5" data-mpi={i}>
            <div className="flex items-baseline justify-between gap-3" data-id="element-132" data-mp="8vaimazy9d68">
              <span className="flex min-w-0 flex-1 items-center gap-2" data-id="element-133" data-mp="22kl6gkurp69s">
                <span className={`h-2.5 w-2.5 shrink-0 rounded-sm ${bar}`} aria-hidden="true" data-id="element-134" data-mp="27id9ob0v4eta" />
                <span className={`min-w-0 flex-1 truncate text-[12.5px] leading-snug ${row.isMine ? 'font-semibold text-navy' : 'text-navy2'}`} data-id="element-135" data-mp="1trhwimjbzbjw">
                  {row.label}
                </span>
                {row.isMine && <span className="shrink-0 rounded-full bg-navy px-1.5 py-0.5 text-[8.5px] uppercase tracking-micro text-paper" data-id="element-136" data-mp="1osojev7yhmk9">
                    You
                  </span>}
              </span>
              <span className="shrink-0 font-display text-[16px] font-bold tabular-nums text-navy" data-id="element-137" data-mp="1et7i0pzqluu3">
                {row.pct}%
                {suffix && <span className="ml-1 text-[9.5px] font-medium text-mut" data-id="element-138" data-mp="3576nrq3mawqi">{suffix}</span>}
              </span>
            </div>
            <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-line" data-id="element-139" data-mp="lzjckvn4xgif">
              <motion.div initial={{
            scaleX: 0
          }} animate={{
            scaleX: row.pct / 100
          }} transition={{
            duration: 0.28,
            delay: 0.08 + i * 0.05,
            ease: EASE
          }} style={{
            transformOrigin: 'left'
          }} className={`h-full ${bar} ${row.isMine ? '' : 'opacity-55'}`} data-id="element-140" data-mp="lx6l9rvhltsp" />
            </div>
          </motion.li>;
    })}
    </ul>;
}